import { Directive, ElementRef, HostListener, Input } from '@angular/core';

declare var bootstrap: any; // for Bootstrap's JS modal

@Directive({
  selector: '[appOpenModal]',
  standalone: false,
})
export class OpenModalDirective {
    @Input('appOpenModal') modalId!: string;

    constructor(private el: ElementRef) {}

    @HostListener('click')
    onClick() {
      const modalEl = document.getElementById(this.modalId);
      if (modalEl) {
        const modal = bootstrap.Modal.getOrCreateInstance(modalEl);
        modal.show();
      } else {
        console.error(`Modal with ID "${this.modalId}" not found`);
      }
    }
  }
